import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";

const LoadingIcon = () => {
    return <FontAwesomeIcon icon={faSpinnerThird} className="text-grey-600 animate-spin p-4" />;
};

export default LoadingIcon;
